/**Dependencies */
import React from 'react';
import { Link } from "react-router-dom";

/**Components */
import { Container, Row, Col, Nav } from "react-bootstrap";
import { FaFacebook, FaInstagram, FaWhatsapp, FaPhoneAlt  } from "react-icons/fa";
import logoBlanco from '../images/logo-blanco.png';

/**Styles */
import '../styles/components/footer.scss'

export const Footer = () => {
  return (
    <footer style={{ backgroundColor: "#001D80", padding: "40px 0" , color:'white' }}>
      <Container fluid className='footer-international'>
        <Row>
          {/* Sección 1: Logo */}
          <Col xs={12} md={2} className="text-center mb-4 mb-md-0">
            <img
              src={logoBlanco}
              alt="Logo"
              style={{ width: "70%" }}
            />
          </Col>

          {/* Sección 2: Nuestros servicios */}
          <Col xs={12} md={2} className="mb-4 mb-md-0">
            <h5>Nuestros Servicios</h5>
            <Nav defaultActiveKey="/" className="flex-column">
              <Nav.Link as={Link} to={"/destinos"}>Destinos</Nav.Link>
              <Nav.Link as={Link} to={"/circuitos"}>Circuitos</Nav.Link>
              <Nav.Link as={Link} to={"/promociones"}>Promociones</Nav.Link>
              <Nav.Link as={Link} to={"/sandals"}>Grupo Sandals</Nav.Link>
              <Nav.Link as={Link} to={"/cursos"}>Cursos & Campamentos</Nav.Link>
              <Nav.Link as={Link} to={"/cruceros"}>Cruceros</Nav.Link>
              <Nav.Link as={Link} to={"/seguro-de-viajero"}>Seguro de Viajero</Nav.Link>
              {/* <Nav.Link as={Link} to={"/mesa-de-regalos"}>Mesa de Regalos</Nav.Link> */}
              <Nav.Link as={Link} to={"/xv-años"}>XV Años</Nav.Link>
            </Nav>
          </Col>

          {/* Sección 3: Nosotros */}
          <Col xs={12} md={2} className="mb-4 mb-md-0">
            <h5>Nosotros</h5>
            <Nav defaultActiveKey="/" className="flex-column">
              <Nav.Link as={Link} to={"/contacto"}>Contacto</Nav.Link>
              <Nav.Link as={Link} to={"/nosotros"}>¿Quiénes somos?</Nav.Link>              
              <Nav.Link as={Link} to={"/preguntas-frecuentes"}>Preguntas Frecuentes</Nav.Link>              
            </Nav>
          </Col>

          {/* Sección 4: Políticas Web */}
          <Col xs={12} md={2} className="mb-4 mb-md-0">
            <h5>Políticas Web</h5>
            <Nav defaultActiveKey="/" className="flex-column">
              <Nav.Link as={Link} to={"/avisos-de-privacidad"}>Avisos de Privacidad</Nav.Link>
              <Nav.Link as={Link} to={"/politica-de-cookies"}>Política de Cookies</Nav.Link>
              <Nav.Link as={Link} to={"/terminos-y-condiciones"}>Términos & Condiciones</Nav.Link>              
            </Nav>
          </Col>

          {/* Sección 5: Redes Sociales y Contacto */}
          <Col xs={12} md={4}>
            <h5>Síguenos en nuestras redes</h5>

            {/* Facebook con texto al lado */}
            <div className="d-flex align-items-center mb-3">                
              <span><FaFacebook className="icon-media"/> <a href='https://www.facebook.com/ViajesTranet' target="_blank" className='text-white'>International Travel Net</a></span>
            </div>

            {/* Instagram con texto al lado */}
            <div className="d-flex align-items-center mb-3">                                           
              <span><FaInstagram className="icon-media"/> <a href='https://www.instagram.com/travelnetcuerna?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==' target="_blank" className='text-white'>@travelnetcuerna</a></span>
            </div>

            {/* Título Encuéntranos y Dirección */}
            <h6>Encuéntranos</h6>
            <p>Vicente Guerrero 110 Int. 9 Col. Lomas de la Selva, Cuernavaca Morelos C.P. 62270</p>

            {/* Contacto y Números */}
            <h6>Contacto</h6>
            <p><FaWhatsapp  className='icon-media'/> <a href="tel:+7772035097" style={{ fontSize:'17px', color: "white"}}>777 203 5097 </a>  -  <a href="tel:+8001234567" style={{ fontSize:'17px', color: "white"}}> 777 179 0074</a></p>
            <p><FaPhoneAlt className='icon-media' /> <a href="tel:+7773125765" style={{ fontSize:'17px', color: "white"}}>777 312 5765 </a> - <a href="tel:+7773128531" style={{ fontSize:'17px', color: "white"}}>777 312 8531 </a> - <a href="tel:+7773189115" style={{ fontSize:'17px', color: "white"}}>777 318 9115 </a></p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
